import React, { FC, memo, CSSProperties } from "react"
import { NewBookingInput, OptionalInputFieldsInput } from "../../../../../generated/graphql"
import FormItem from "antd/es/form/FormItem"
import { Select } from "antd"
import { NewBookingInputKeys } from "../../../BookingSummary/BookingSummary"
import css from "../../StepSummary2.module.css"

type FoundUsInputProps = {
    field: OptionalInputFieldsInput
    bookingData?: NewBookingInput | undefined
    updateBookingData: (key: NewBookingInputKeys, value: any) => void
    style?: CSSProperties
}

const { Option } = Select

const FoundUsInput: FC<FoundUsInputProps> = ({ field, bookingData, updateBookingData, style }) => {
    const { enabeld, options, label, description } = field

    if (enabeld === false || !options || options.length === 0) return null

    return (
        <FormItem label={label}>
            <Select
                style={{ width: "100%" }}
                value={bookingData?.foundUs}
                onChange={(value) => {
                    console.log("value:::", value)
                    updateBookingData("foundUs", value)
                }}
                defaultValue='Keine Angabe'
            >
                {options.map((option) => (
                    <Option key={option} value={option}>
                        {option}
                    </Option>
                ))}
            </Select>
            <div className={css.inputDescription}>{description}</div>
        </FormItem>
    )
}

export default memo(FoundUsInput)
